import { isoToDateString, isoToDateTimeString } from "utils/date";

export default [

  { field: 'name', headerAlign: 'center', headerName: 'Касса', width: 160,
    valueGetter: (value, row) => `${row.model} - ЗН ${row.factoryNumber}`},

  { field: 'version', flex: 1, headerAlign: 'center', headerName: 'Версия', align: 'center' },

  { field: 'build', flex: 1, headerAlign: 'center', headerName: 'Сборка', align: 'center' },

  { field: 'setupAt', headerAlign: 'center', headerName: 'Установка', flex: 1, align: 'center',
    valueGetter: (value) => isoToDateTimeString(value)},  

  { field: 'updateAt', headerAlign: 'center', headerName: 'Обновлено', flex: 1, align: 'center',
    valueGetter: (value) => isoToDateTimeString(value)},  
  
  { field: 'execAt', headerAlign: 'center', headerName: 'Последний запуск', flex: 1,
    valueGetter: (value) => isoToDateTimeString(value), align: 'right'}

];    